/*
 * @Author: caiqin.xie
 * @since: 2023-06-28 17:12:46
 * @lastTime: 2023-11-07 10:15:52
 * @LastEditors: caiqin.xie
 * @message:
 */
import React from "react";
import { Switch, Route } from "react-router-dom";
import routes from './routes'
import PageTemplate from './PageTemplate'
import "./common/styles/common.scss";
import './common/styles/rewriteArco.scss'
import "./common/styles/base.scss";
import './common/styles/rewriteSwiper.scss'
const App = (props:any) => {
  interface Obj {
    [key: string]: string;
  }
  return (
    <>
      <Switch>
        {routes.map(route => {
          return (
            <Route
              path={route.path}
              key={route.path}
              exact={route.exact}
              render={(props) => (
                // @ts-ignore
                <PageTemplate {...props} route={route}>
                  <route.component />
                </PageTemplate>
              )}
            ></Route>
          )
        })}
      </Switch>
    </>

  )
}

export default App
